import "./LongevityAndFitness.module.css";
import Header from "@/reusable_sections/Header";
import HeroLongevityFitness from "./sections/HeroLongevityFitness";
import LongevityPhilosophy from "./sections/LongevityPhilosophy";
import PhysicalCapability from "./sections/PhysicalCapability";
import CardiorespiratoryFitness from "./sections/CardiorespiratoryFitness";
import MovementAssessment from "./sections/MovementAssessment";
import RestingEnergyRequirements from "./sections/RestingEnergyRequirements";
import AudienceSegments from "./sections/AudienceSegments";
import AssessmentPathway from "./sections/AssessmentPathway";
import PhysicalCapacityPathway from "./sections/PhysicalCapacityPathway";
import MeasureChange from "./sections/MeasureChange";
import FitnessTesting from "./sections/FitnessTesting";
import StatementBanner from "./sections/StatementBanner";
import DataInterpretation from "./sections/DataInterpretation";
import LongevityFitnessCta from "./sections/LongevityFitnessCta";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function LongevityAndFitnessPage() {
  return <div>
      <Header />
      <HeroLongevityFitness />
      <LongevityPhilosophy />
      <PhysicalCapability />
      <CardiorespiratoryFitness />
      <MovementAssessment />
      <RestingEnergyRequirements />
      <AudienceSegments />
      <AssessmentPathway />
      <PhysicalCapacityPathway />
      <MeasureChange />
      <FitnessTesting />
      <StatementBanner />
      <DataInterpretation />
      <LongevityFitnessCta />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}